export const socialsData = {
  github: 'https://github.com/Ayush-k-Shukla',
  linkedIn: 'https://www.linkedin.com/in/ayush-kumar-shukla/',
  mail: 'shuklaayushkumar27@gmail.com',
  leetcode: 'https://leetcode.com/the_ayush/',
};
